import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const StarWrapper = styled.button`
  border: none;
  background-color: inherit;
  height: ${props => `${props.height}px`};
  width: ${props => `${props.width}px`};
  padding: 0;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-content: center;
  &:active, &:focus {
    outline: none;
  }
`;

const Star = ({ height, width, color, onClick }) => (
  <StarWrapper height={height} width={width} onClick={onClick} >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      x="0px"
      y="0px"
      viewBox="0 0 60 60"
      xmlSpace="preserve"
      width={`${width}px`}
      height={`${height}px`}
    >
      <g>
        <path
          d="M48.856,22.73c0.983-0.958,1.33-2.364,0.906-3.671c-0.425-1.307-1.532-2.24-2.892-2.438l-12.092-1.757  c-0.515-0.075-0.96-0.398-1.19-0.865L28.182,3.043c-0.607-1.231-1.839-1.996-3.212-1.996c-1.372,0-2.604,0.765-3.211,1.996  L16.352,14c-0.23,0.467-0.676,0.79-1.191,0.865L3.069,16.622c-1.359,0.197-2.467,1.131-2.892,2.438  c-0.424,1.307-0.077,2.713,0.906,3.671l8.749,8.528c0.373,0.364,0.544,0.888,0.456,1.4L8.224,44.701  c-0.183,1.06,0.095,2.091,0.781,2.904c1.066,1.267,2.927,1.653,4.415,0.871l10.814-5.686c0.452-0.237,1.021-0.235,1.472,0  l10.815,5.686c0.526,0.277,1.087,0.417,1.666,0.417c1.057,0,2.059-0.47,2.748-1.288c0.687-0.813,0.964-1.846,0.781-2.904  l-2.065-12.042c-0.088-0.513,0.083-1.036,0.456-1.4L48.856,22.73z"
          fill={color}
        />
      </g>
    </svg>
  </StarWrapper>
);

Star.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  onClick: PropTypes.func
};

Star.defaultProps = {
  color: "#1cbb78",
  onClick: null,
  height: 15,
  width: 15
};

export default Star;


// WEBPACK FOOTER //
// ./src/components/share/Star.js